
import React from 'react';



function Ourjourney() {
    return (

        <section className='journey-section'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <div className='journey-section-title text-center'>
                            <h2>My Journey</h2>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-12 roadbgimg text-center'>
                        <div className='roadway'>
                            <img src="assets/images/our-journery-road.svg" />
                        </div>
                        <div className='sixth-set'>
                            <div className='sixth-set-inner flex-column-reverse flex-md-row'>
                                <div className='sixth-content'>
                                    <p>Dr. Mahadevan began his medical <br></br> journey  at JSS Medical College, Mysore</p>
                                </div>
                                <div className='sixth-image'>
                                    <img src="assets/images/1999.svg" alt="2021 milestone" />
                                </div>
                            </div>
                        </div>
                        <div className='fivth-set'>
                            <div className='fivth-set-inner flex-column-reverse flex-md-row'>
                                <div className='fivth-content'>
                                    <p>Pursued MD in General Medicine at  <br></br>PSG Medical College, Coimbatore</p>
                                </div>
                                <div className='fivth-image'>
                                    <img src="assets/images/2006.svg" alt="2021 milestone" />
                                </div>
                            </div>
                        </div>
                        <div className='fourth-set'>
                            <div className='fourth-set-inner flex-column-reverse flex-md-row'>
                                <div className='fourth-image'>
                                    <img src="assets/images/2010.svg" alt="2021 milestone" />
                                </div>
                                <div className='fourth-content'>
                                    <p>Completed Indian Diploma in Critical <br></br> Care (IDCCM) at Apollo Hospital</p>
                                </div>
                            </div>
                        </div>
                        <div className='third-set'>
                            <div className='third-set-inner flex-column-reverse flex-md-row'>
                                <div className='third-content'>
                                    <p>Served in Critical Care at MIOT Hospitals, <br></br>leading the COVID team and managing<br></br> critically ill patients.</p>
                                </div>
                                <div className='third-image'>
                                    <img src="assets/images/2015.svg" alt="2021 milestone" />
                                </div>
                            </div>
                        </div>
                        <div className='second-set'>
                            <div className='second-set-inner flex-column-reverse flex-md-row'>
                                <div className='second-image'>
                                    <img src="assets/images/2020.svg" alt="2021 milestone" />
                                </div>
                                <div className='second-content'>
                                    <p>Joined Maya Nursing Home as Senior<br></br> Physician, focusing on critical care, diabetes,<br></br> and geriatric medicine.</p>
                                </div>
                            </div>
                        </div>
                        <div className='first-set'>
                            <div className='first-set-inner flex-column-reverse flex-md-row'>
                                <div className='first-content'>
                                    <p>Expanding horizons with the <br></br>launch of Good New Health Care</p>
                                </div>
                                <div className='first-image'>
                                    <img src="assets/images/2026.svg" alt="2021 milestone" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >

    );
}

export default Ourjourney;


